<template>
  <div class="row">
    <div class="col-lg-10">
      <h3
        class="mt-1 page-title-heading"
        data-test="change-password-heading"
      >
        {{ $localize('ChangePassword') }}
      </h3>
      <p data-test="change-password-message">
        {{ $localize('ChangePasswordInstructions') }}
      </p>
    </div>
  </div>
</template>
